import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import './index.scss'
import { capitalizeFirstLetter } from "../../../../utils/common"
const PlanInfoHeader = ({ _plan, _cancel }) => {
	let history = useHistory()
	return (
		<>
			<div className="user-plan-info d-flex">
				<div className="plan d-flex">
					{/* <span className='desc d-inline-flex align-items-center'>
						<span className='type'>{_plan?.current_pan && _plan?.subscription_status === 'active' && capitalizeFirstLetter(_plan?.current_pan) || 'Free'} </span>
						{_plan?.subscription_status === 'active' && <span className="price"><span>${_plan?.amount} /</span> Month</span>}
					</span> */}
					{/* <Button color="link" className='upgrade-btn' onClick={() => { history.push('/pricing') }}>
						Upgrade Plan
					</Button> */}
				</div>
				{/*_plan && <Button type="button" onClick={(val) => { if (_plan?.subscription_status === 'active') _cancel() }} className='cancel-btn btn btn-outline-danger'>{_plan?.subscription_status === 'active' ? 'Cancel Plan' : 'Cancelled'}</Button>*/}
			</div>
		</>
	)
};

export default PlanInfoHeader;